import { useCallback, useState } from 'react'
import classnames from 'classnames'

import { getNextSorting } from './getNextSorting'
import { SortingIcon } from './SortingIcon'

export type SortingOrder = 'asc' | 'desc' | undefined

type SortingIconButtonProps = {
    name: string
    order: SortingOrder
    className?: string
    onClick?: () => void
    groupControlledStyles?: boolean
}

export const SortingIconButton: React.FC<SortingIconButtonProps> = (props) => {
    const { name, className, onClick, order, groupControlledStyles } = props

    const buttonClassname = classnames(
        'group/icon p-1 rounded-lg outline-0',
        {
            'hover:bg-blue-100 active:bg-blue-200': !groupControlledStyles,
            'group-hover/sorting:bg-blue-100 group-active/sorting:bg-blue-200':
                !!groupControlledStyles,
        },
        className
    )

    return (
        <button
            className={buttonClassname}
            data-testid={`${name}-sorting-icon`}
            onClick={onClick}
        >
            <SortingIcon order={order} />
        </button>
    )
}

type UncontrolledSortingIconButtonProps = {
    name: string
    onChange?: (order: SortingOrder) => void
    className?: string
}

export const UncontrolledSortingIconButton: React.FC<
    UncontrolledSortingIconButtonProps
> = (props) => {
    const { onChange, name, className } = props
    const [order, setOrder] = useState<SortingOrder>(undefined)

    const onClick = useCallback(() => {
        setOrder((order) => {
            const nextOrder = getNextSorting(order)
            onChange?.(nextOrder)
            return nextOrder
        })
    }, [onChange])

    return (
        <SortingIconButton
            onClick={onClick}
            order={order}
            name={name}
            className={className}
        />
    )
}
